<template>
  <e-dialog v-model="isOfflineRequestErrorShow" width="520px" hide-title center :fullscreen="false">
    <div class="offline-request-error">
      <div class="h3">Сеть недоступна</div>
      <div class="my-10">
        <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g style="mix-blend-mode: luminosity" opacity="0.2">
            <path
              d="M56.4921 86.2886C62.1683 87.5572 67.3349 88.0123 72.648 93.0074C83.6624 103.363 80.6245 121.067 98.6787 129.821C114.114 137.306 128.404 125.568 133.598 117.022C143.724 100.364 151.767 75.7815 152.842 49.3649C153.876 23.9619 146.692 10.8201 131.481 5.3698C116.271 -0.080469 84.7021 8.01381 57.6359 23.0242C36.0474 34.9967 24.9089 47.9646 29.3957 65.8551C32.8565 79.6546 46.3493 84.0218 56.4921 86.2886Z"
              fill="url(#paint0_linear_5002_5071)"
            />
          </g>
          <path
            d="M60.6663 76C74.5812 76 86.1253 86.1502 88.2986 99.4504C96.3924 100.421 102.666 107.311 102.666 115.667C102.666 124.687 95.3537 132 86.333 132H30.333C18.735 132 9.33301 122.598 9.33301 111C9.33301 99.402 18.735 90 30.333 90C32.2906 90 34.1856 90.2679 35.9835 90.7689C40.7059 81.9775 49.9881 76 60.6663 76Z"
            stroke="#C2C6D2"
            stroke-width="3"
            stroke-linecap="round"
          />
          <path d="M14 146.001L93.3333 66.668" stroke="#C2C6D2" stroke-width="3" stroke-linecap="round" />
          <defs>
            <linearGradient
              id="paint0_linear_5002_5071"
              x1="245.89"
              y1="-515.523"
              x2="-27.266"
              y2="-509.883"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F6CA58" />
              <stop offset="0.297322" stop-color="#F2B662" />
              <stop offset="0.706899" stop-color="#EC907C" />
              <stop offset="1" stop-color="#E97593" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="paragraph-m">Проверьте ваше интернет-соединение</div>
      <e-btn variant="primary" class="mt-10" @click="close"> Закрыть </e-btn>
    </div>
  </e-dialog>
</template>

<script setup lang="ts">
import EDialog from '@/core/components/modals/Dialog.vue';
import { EBtn } from '@/core/components/ui';
import { useAppState } from '@/core/store/useAppState';

const { isOfflineRequestErrorShow } = useAppState();

const close = () => {
  isOfflineRequestErrorShow.value = false;
};
</script>

<style scoped lang="scss">
.offline-request-error {
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 20px;

  text-align: center;
}
</style>
